import type { AnalyticsManager } from '@/analytics/AnalyticsManager';
import type { IConfig } from '@/configuration/models/IConfig';
import type { IDocumentScheme } from '@models/document/IDocumentScheme';
import type { IDocumentResolverRunMetric } from './buildDocumentResolver';

type ApplicationConfig = IConfig['application'];
type FlowIdentity = Pick<IDocumentScheme, 'flowKey' | 'flowName'>;

export const isDocumentResolverValidationEnabled = (application: ApplicationConfig): boolean =>
    application.useResolverValidation === true;

export const createDocumentResolverTelemetryReporter = (
    analytics: Pick<AnalyticsManager, 'trackEvent'>,
    flow: FlowIdentity,
): ((metric: IDocumentResolverRunMetric) => void) => {
    const flowName = flow.flowKey || flow.flowName || 'unknown';

    return (metric) => {
        const eventBase = { category: 'Document validation', name: flowName };
        const measurements: ReadonlyArray<readonly [suffix: string, value: number]> = [
            [metric.outcome, Math.round(metric.durationMs)],
            ['formula-evaluations', metric.formulaEvaluationCount],
            ['network-requests', metric.networkRequestCount],
            ['validation-errors', metric.validationErrorCount],
            ['evaluator-errors', metric.evaluatorErrorCount],
        ];
        for (const [suffix, value] of measurements) {
            analytics.trackEvent({ ...eventBase, action: `resolver-${metric.mode}-${suffix}`, value });
        }
    };
};
